import React, { useState } from "react";
import s from "./styles.module.css";

const ToggleButtonGroup = ({ buttons, onSelect }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleClick = (index) => {
    setActiveIndex(index);
    if (onSelect) {
      onSelect(index);
    }
  };

  return (
    <div className={s.container}>
      {buttons.map((button, index) => (
        <button
          key={index}
          className={`${s.button} ${
            activeIndex === index ? s.active : ""
          }`}
          onClick={() => handleClick(index)}
        >
          {button}
        </button>
      ))}
    </div>
  );
};

export default ToggleButtonGroup;
